import { useQuery } from '@tanstack/react-query';
import OrganisationsService from '../services/OrganisationsService';
import { ORGANISATIONS_QUERY_KEY } from '../constants/Constant';
import { QUERY_STALE_TIME_MS } from 'constants/appConstants';
import { formatOrganisationForTable } from '../utils/OrganisationUtils';
import useFetchUserProfile from './useFetchUserProfile';

export const useFetchOrganisations = () => {
  const { data: userData, isError: isUserDataError } = useFetchUserProfile();

  return useQuery({
    queryKey: [ORGANISATIONS_QUERY_KEY],
    queryFn: OrganisationsService.FetchAllOrganisations,
    select: (data) => {
      if (userData && userData.orgAccesses && userData.orgAccesses.length > 0) {
        const allowedOrgIds = userData.orgAccesses.map(
          (access: { orgId: string }) => access.orgId
        );

        return data
          .filter((org) => allowedOrgIds.includes(org.orgId || org.id))
          .map(formatOrganisationForTable);
      }

      return isUserDataError ? [] : data.map(formatOrganisationForTable);
    },
    enabled: !!userData && !isUserDataError,
    staleTime: QUERY_STALE_TIME_MS,
  });
};

export default useFetchOrganisations;
